import { ChipSwitch, ChipSwitchButton } from '../../components/ChipSwitch'
import { useFinancialsTableContext } from '../../components/financials-table'
import { DividendDataEnum, DividendSettings } from './types'

export default function WidgetSettingsSection() {
  const { settings, setSettings } = useFinancialsTableContext<DividendSettings>()

  const toggleSetting = (key: keyof DividendSettings, value: DividendSettings[keyof DividendSettings]) => {
    setSettings({
      ...settings,
      [key]: value,
    })
  }

  return (
    <ChipSwitch size="small" label="Data">
      <ChipSwitchButton
        active={settings[DividendDataEnum.yoyChange]}
        onClick={() => {
          toggleSetting(DividendDataEnum.yoyChange, !settings[DividendDataEnum.yoyChange])
        }}
      >
        YoY Growth
      </ChipSwitchButton>
      <ChipSwitchButton
        active={settings[DividendDataEnum.yoyChangePct]}
        onClick={() => {
          toggleSetting(DividendDataEnum.yoyChangePct, !settings[DividendDataEnum.yoyChangePct])
        }}
      >
        YoY Growth %
      </ChipSwitchButton>
    </ChipSwitch>
  )
}
